import { css, useTheme } from '@emotion/react';
import { SubTitle } from '~/pages/Main/index.styled';
import CharacterCard from '~/components/common/CharacterCard/CharacterCard';
import { useGetListByCharacterTypeQuery } from '~/features/character';
import { useCharacterLikeActions, useCreateChatRoom } from '~/hooks';

export default function NeedHelp() {
  const theme = useTheme();

  const { data } = useGetListByCharacterTypeQuery({ type: 'concept' });
  const { handleLikeClick } = useCharacterLikeActions({
    type: 'concept',
  });
  const { handleCreateRoomClick } = useCreateChatRoom();

  return (
    <>
      {/* {isCreateRoomPending && <FullScreenLoading />} */}

      <div
        css={css`
          display: block;
        `}
      >
        <div
          css={css`
            display: block;
            margin-bottom: 16px;
          `}
        >
          <SubTitle>Need help?</SubTitle>
        </div>
        <div
          css={css`
            display: grid;
            grid-template-columns: repeat(2, 1fr);
            margin-right: ${theme.layout.section_side};
            gap: 8px;

            @media (min-width: 480px) {
              grid-template-columns: repeat(3, 1fr);
            }
          `}
        >
          {data.map(
            ({
              character_id,
              character_image,
              character_name,
              character_desc,
              is_liked,
              create_username,
              liked_count,
              type,
            }) => (
              <CharacterCard
                key={`NeedHelp${character_id}`}
                id={character_id}
                image={character_image}
                name={character_name}
                desc={character_desc}
                create_username={create_username}
                is_liked={is_liked}
                liked_count={liked_count}
                type={type}
                handleLikeClick={handleLikeClick}
                handleCardClick={handleCreateRoomClick}
              />
            ),
          )}
        </div>
      </div>
    </>
  );
}
